import {scrollbarProcess} from '../components/Scrollbar';

$ = jQuery.noConflict();

$(document).ready(function () {
  /**
   * SCROLLBAR
   */
  const $scrollBar = $('#scroll-bar');
  if ($scrollBar.length) {
    scrollbarProcess($scrollBar[0]);

    $(window).on('scroll', function () {
        scrollbarProcess($scrollBar[0]);
    });
  }

  /**
   * SOCIAL LINKS
   */
  $('.social-link').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    if ($this.hasClass('social-link-bell')) {
      const $target = $(e.target);
      if (!$target.closest('.hs-form').length) {
        $this.toggleClass('clicked');
      }
    } else if ($this.hasClass('social-link-linkedin')) {
      shareOnLinkedIn();
    } else if ($this.hasClass('social-link-facebook')) {
      shareOnFacebook();
    } else if ($this.hasClass('social-link-twitter')) {
      shareOnTwitter();
    } else if ($this.hasClass('social-link-mail')) {
      sendUrlToMail();
    } else if ($this.hasClass('social-link-copy')) {
      copyPageUrl();
    }
  });
  const $body = $('body');
  $body.on('click', function () {
    $('.clicked').removeClass('clicked');
  });
  // $body.on('click','.hs-button', function (e){
  //   $(e.target).closest('form').submit();
  // });

  /**
   * SLIDER
   */
  let is_slider_init = false;

  function initSlider() {
    $('.read-more-blogs').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });
  }
  function destroySlider() {
    $('.read-more-blogs').slick('unslick');
  }
  function checkWindowSize() {
    if ($(window).width() < 767) {
      if (!is_slider_init) {
        initSlider();
        is_slider_init = true;
      }
    } else {
      if (is_slider_init) {
        destroySlider();
        is_slider_init = false;
      }
    }
  }

  checkWindowSize();
  $(window).resize(function() {
    checkWindowSize();
  });

  /**
   * MARKER
   */
  // $('mark.has-inline-color').mark();
  $('mark.has-inline-color').each(function() {
    const $this = $(this);
    $this.addClass('no-marked');
    const style = $this.attr('style');
    const match = /background-color:\s*([^;]+)/.exec(style);

    if (match && match[1]) {
      const mark_element = $('<marker>');
      mark_element.css('background', 'transparent)');
      mark_element.data('background', match[1]);
      $this.html(mark_element.text($this.text()));
    }
  });

  $(document).on('scroll', function () {
      $('.no-marked').each(function () {
        const $this = $(this);
        if (is_element_visible($this)) {
          mark_element($this);
        }
      });
  });

});
function shareOnFacebook() {
  window.open(
    'https://www.facebook.com/sharer/?u=' +
    encodeURIComponent(window.location.href),
    'linkedin-share-dialog',
    'width=626,height=436'
  )
}

function shareOnLinkedIn() {
  window.open(
    'https://www.linkedin.com/sharing/share-offsite/?url=' +
    encodeURIComponent(window.location.href),
    'linkedin-share-dialog',
    'width=626,height=436'
  )
}

function shareOnTwitter() {
  window.open(
    'https://twitter.com/intent/tweet?url=' +
    encodeURIComponent(window.location.href),
    'twitter-share-dialog',
    'width=626,height=436'
  )
}

function sendUrlToMail() {
  const pageUrl = window.location.href
  const mailtoLink =
    'mailto:?subject=Check%20out%20this%20page&body=' +
    encodeURIComponent(
      'I thought you might find this page interesting:\n\n' + pageUrl
    )
  window.location.href = mailtoLink
}

function copyPageUrl() {
  const pageUrl = window.location.href
  let tempInput = document.createElement('input')
  tempInput.value = pageUrl
  document.body.appendChild(tempInput)
  tempInput.select()
  document.execCommand('copy')
  document.body.removeChild(tempInput)
  alert('The URL was copied: ' + pageUrl)
}

function is_element_visible($element) {
  $element = $($element);
  const s_top = $(document).scrollTop() + $(window).height() * 0.66;
  const yes = $element.offset().top;

  return s_top > yes;
}

function mark_element($element) {
  const mark_element = $element.find('marker');
  const background_color = mark_element.data('background'); 
  mark_element.css('background', 'linear-gradient(to right, ' +background_color + ' 50%,transparent 50%)');
  mark_element.addClass('animate');

  $element.removeClass('no-marked');
}